import { render, staticRenderFns } from "./groupActiveCodeStatisticsDetail.vue?vue&type=template&id=0b4ef597&scoped=true&"
import script from "./groupActiveCodeStatisticsDetail.vue?vue&type=script&lang=js&"
export * from "./groupActiveCodeStatisticsDetail.vue?vue&type=script&lang=js&"
import style0 from "./groupActiveCodeStatisticsDetail.vue?vue&type=style&index=0&id=0b4ef597&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4ef597",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b4ef597')) {
      api.createRecord('0b4ef597', component.options)
    } else {
      api.reload('0b4ef597', component.options)
    }
    module.hot.accept("./groupActiveCodeStatisticsDetail.vue?vue&type=template&id=0b4ef597&scoped=true&", function () {
      api.rerender('0b4ef597', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group/components/groupActiveCodeStatisticsDetail.vue"
export default component.exports